import { Link } from 'react-router-dom';
import { MapPin, Facebook, Wrench, Heart } from 'lucide-react';
import { EditableText } from './EditableText';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#193460] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Created by Mushonga Systems — above quick links */}
        <div className="mb-8 text-center">
          <a
            href="https://mushongasystems.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-mushonga-link"
            className="text-sm font-medium text-gray-200 hover:text-[#E87B6A] transition-colors duration-300 inline-block"
          >
            Created by Mushonga Systems
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section with Cafe Logo and Facebook Logo */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_waste-less-hub-1/artifacts/918kjlll_image.png"
                alt="Repair Cafe Logo"
                className="w-10 h-10 rounded-full"
              />
              <a
                href="https://www.facebook.com/peterboroughrepaircafeuk?mibextid=wwXIfr&rdid=XK3N7EsvPbJVRdwr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1PFFd2wca5%2F%3Fmibextid%3DwwXIfr#"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <div className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center">
                  <Facebook className="w-6 h-6 text-white" />
                </div>
              </a>
              <div>
                <h3 className="font-bold text-lg">Peterborough</h3>
                <p className="text-sm text-gray-300">Repair Cafe UK</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              <EditableText contentKey="footer.tagline" as="span" multiline>
                Helping local people repair broken portable household items for free. Join us on the first Saturday of every month!
              </EditableText>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/repair-request" className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm">
                  Repair Request
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 text-sm"
                  data-testid="footer-privacy-policy"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <div className="space-y-3">
              <Link
                to="/repair-request#enquiry-form"
                className="flex items-start space-x-3 text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 group"
                data-testid="footer-send-enquiry"
              >
                <Wrench className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span className="text-sm">Send an enquiry →</span>
              </Link>
              <a
                href="https://www.facebook.com/peterboroughrepaircafeuk?mibextid=wwXIfr&rdid=XK3N7EsvPbJVRdwr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1PFFd2wca5%2F%3Fmibextid%3DwwXIfr#"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-[#E87B6A] transition-colors duration-300 group"
              >
                <Facebook className="w-5 h-5" />
                <span className="text-sm">Follow us on Facebook</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Peterborough Repair Cafe UK. All rights reserved.
            </p>
            <p className="flex items-center text-gray-400 text-sm">
              Made with <Heart className="w-4 h-4 mx-1 text-[#E87B6A] fill-current" /> for our community
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
